module.exports = __webpack_public_path__ + "static/media/PM11.31b830f6.JPG";